var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"background"},[_c('div',{staticClass:"fill",style:({ 
                width: _vm.progressPercentage + '%',
                backgroundColor: _vm.current >= _vm.min ? '#4CAF50' : '#E10274'
            })})])])}
var staticRenderFns = []

export { render, staticRenderFns }